import { FastlyImageParams, serialiseFastlyParams } from './fastly-image-params';

const FALLBACK_PARAMS: FastlyImageParams = { quality: 65, format: 'auto' };
export const FALLBACK_PRESET = serialiseFastlyParams(FALLBACK_PARAMS);
const AVATAR_LANDSCAPE_PRESET: FastlyImageParams = { width: 288, height: 216, quality: 95, format: 'auto', crop: { smart: true } };
const AVATAR_LARGE_PRESET: FastlyImageParams = { width: 480, height: 480, quality: 95, format: 'auto', crop: { smart: true } };
const AVATAR_STANDARD_PRESET: FastlyImageParams = { width: 200, height: 200, quality: 95, format: 'auto', crop: { smart: true } };
const CAMPAIGN_DEFAULT_PRESET: FastlyImageParams = { width: 530, height: 400, quality: 85, format: 'auto', fit: 'crop' };
const CAMPAIGN_SMALL_PRESET: FastlyImageParams = { width: 340, height: 255, quality: 65, format: 'auto', fit: 'crop' };
const CAMPAIGN_TINY_PRESET: FastlyImageParams = { width: 96, height: 64, format: 'auto', fit: 'crop' };
const DEFAULT_DESKTOP_TILE_PRESET: FastlyImageParams = { width: 900, height: 600, quality: 65, format: 'auto', fit: 'bounds' };
const DEFAULT_MOBILE_TILE_PRESET: FastlyImageParams = { width: 530, height: 400, quality: 65, format: 'auto', fit: 'crop' };
const DEFAULT_TILE_PRESET: FastlyImageParams = { width: 340, height: 255, quality: 65, format: 'auto', fit: 'crop' };
const FLOOR_PLAN_GALLERY_PRESET: FastlyImageParams = { width: 423, height: 240, quality: 65, format: 'auto', fit: 'bounds' };
const FLOOR_PLAN_MODAL_PRESET: FastlyImageParams = { width: 768, height: 1024, quality: 65, format: 'auto', fit: 'bounds' };
const IMAGE_RESIZE_CAMPAIGN_THUMBNAIL_PRESET: FastlyImageParams = {
  width: 120,
  height: 80,
  quality: 75,
  format: 'auto',
  crop: { smart: true },
};
const PAGE_META_THUMBNAIL_PRESET: FastlyImageParams = { width: 800, height: 500, quality: 75, format: 'auto', crop: { smart: true } };
const PAGE_META_THUMBNAIL_LARGE_PRESET: FastlyImageParams = { width: 1140, height: 900, quality: 75, format: 'auto', fit: 'crop' };
const PROFILE_BANNER_LOGO_PRESET: FastlyImageParams = { height: 80, quality: 95, format: 'auto', fit: 'bounds' };
const PROFILE_COVER_PRESET: FastlyImageParams = { width: 955, height: 200, quality: 99, format: 'auto', fit: 'crop' };
const SQUARE_200_PRESET: FastlyImageParams = { width: 200, height: 200, quality: 95, format: 'auto', crop: { smart: true } };
const SQUARE_150_PRESET: FastlyImageParams = { width: 150, height: 150, quality: 95, format: 'auto', crop: { smart: true } };
const PROFILE_GALLERY_PRESET: FastlyImageParams = { width: 220, height: 192, quality: 95, format: 'auto', fit: 'crop' };
const SQUARE_180_PRESET: FastlyImageParams = { width: 180, height: 180, quality: 85, format: 'auto', fit: 'bounds' };
const CAMPAIGN_GALLERY_HERO_PRESET: FastlyImageParams = { width: 774, height: 416, quality: 75, format: 'auto', crop: { smart: true } };

export const IMAGE_OPTIMISE_PRESETS = {
  AvatarLandscape: AVATAR_LANDSCAPE_PRESET,
  AvatarLarge: AVATAR_LARGE_PRESET,
  AvatarStandard: AVATAR_STANDARD_PRESET,
  CampaignDefault: CAMPAIGN_DEFAULT_PRESET,
  CampaignSmall: CAMPAIGN_SMALL_PRESET,
  CampaignGalleryHero: CAMPAIGN_GALLERY_HERO_PRESET,
  CampaignThumbnail: IMAGE_RESIZE_CAMPAIGN_THUMBNAIL_PRESET,
  CampaignTiny: CAMPAIGN_TINY_PRESET,
  DefaultDesktopTile: DEFAULT_DESKTOP_TILE_PRESET,
  DefaultMobileTile: DEFAULT_MOBILE_TILE_PRESET,
  DefaultTile: DEFAULT_TILE_PRESET,
  Fallback: FALLBACK_PARAMS,
  FloorPlanGallery: FLOOR_PLAN_GALLERY_PRESET,
  FloorPlanModal: FLOOR_PLAN_MODAL_PRESET,
  PageMetaThumbnail: PAGE_META_THUMBNAIL_PRESET,
  PageMetaLargeThumbnail: PAGE_META_THUMBNAIL_LARGE_PRESET,
  ProfileBannerLogo: PROFILE_BANNER_LOGO_PRESET,
  ProfileCover: PROFILE_COVER_PRESET,
  ProfileGallery: PROFILE_GALLERY_PRESET,
  Square150: SQUARE_150_PRESET,
  Square180: SQUARE_180_PRESET,
  Square200: SQUARE_200_PRESET,
} as const;

export type ImageOptimisePreset = keyof typeof IMAGE_OPTIMISE_PRESETS;
export const mapImagePresetKeyToConfig = (p: ImageOptimisePreset): string => serialiseFastlyParams(IMAGE_OPTIMISE_PRESETS[p]);

export function isImagePresetKey(k: string): k is ImageOptimisePreset {
  return Object.keys(IMAGE_OPTIMISE_PRESETS).includes(k);
}
